export { updateName } from './updateName';
export { updateAvatar } from './updateAvatar';
export { updatePassword } from './updatePassword';
